/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerDto } from '../../models/customer-dto';

export interface ApiCustomerCustomerIdCollectedServiceDateGet$Json$Params {
  customerId: number;
  collectedServiceDate: string;
}

export function apiCustomerCustomerIdCollectedServiceDateGet$Json(http: HttpClient, rootUrl: string, params: ApiCustomerCustomerIdCollectedServiceDateGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerDto>> {
  const rb = new RequestBuilder(rootUrl, apiCustomerCustomerIdCollectedServiceDateGet$Json.PATH, 'get');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.path('collectedServiceDate', params.collectedServiceDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerDto>;
    })
  );
}

apiCustomerCustomerIdCollectedServiceDateGet$Json.PATH = '/api/Customer/{customerId}/{collectedServiceDate}';
